export const MAIN_LOGO: string = window._env_.VITE_LOGO_FULL || import.meta.env.VITE_LOGO_FULL;
export const MAIN_LOGO_DARK: string = window._env_.VITE_LOGO_FULL_DARK || import.meta.env.VITE_LOGO_FULL_DARK;
